export const getters = {
    list: state => state.list,
    columns: state => state.columns,
    model: state => state.model,
    order_payments: state => state.order_payments,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
    prices: state => state.prices,
};